import { render, staticRenderFns } from "./NeqasSampleReportTable.vue?vue&type=template&id=876b2e48"
import script from "./NeqasSampleReportTable.vue?vue&type=script&lang=js"
export * from "./NeqasSampleReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports